module.exports = __webpack_public_path__ + "img/ask_bg_check.81d2dc6b.svg";